module.exports = __webpack_public_path__ + "img/img5_zhTc.59508f19.png";